
const state = {
  articles: [
    {
      caption: "One face to the customer - Alles aus einer Hand!",
      intro: "Als renommierter Dienstleister im Bau- und Handwerksbereich bieten wir Ihnen bei JMS Menikheim GmbH & Co. KG ein umfassendes Leistungsportfolio – von klassischen Maler- und Innenausbauarbeiten bis hin zu spezialisierten Handwerkerleistungen, Energieberatung und Bauprojektleitung.\nUnsere Kunden profitieren von kompetenter Beratung, zuverlässiger Ausführung und ganzheitlichen Lösungen, die sowohl Wohn- als auch Gewerbeobjekte nachhaltig aufwerten. Mit Erfahrung, Leidenschaft und technischem Know-how realisieren wir Projekte jeder Größenordnung – termintreu, professionell und mit Blick für Details. Überzeugen Sie sich selbst von usnerem Portfolio:",
      image: "oneface.png", 
      width: 3
    }, {
      caption: "Sanitär- und Heiztechnik – Komfort & Sicherheit",
      intro: "Mit moderner Sanitär- und Heiztechnik schaffen wir funktionale, langlebige Lösungen für Bad, WC und Heizsysteme.\n\nUnsere Leistungen:\nInstallation und Modernisierung von Sanitäranlagen\nHeizungsinstallation und -wartung\nOptimierung bestehender Systeme",
      image: "bauen.jpg",
      width: 1
    },{
      caption: "Elektrik – Sicher & Zukunftsfähig",
      intro: "Elektrische Systeme sind heute mehr als Stromleitungen – sie sind das Rückgrat smart vernetzter Gebäude.\n\nUnsere Leistungen:\nElektroinstallation und -erweiterung\nBeleuchtungskonzepte\nSteckdosen, Sicherungs- und Verteilertechnik\nBeispiele:\n✔ Beleuchtungskonzepte nach Bedarf\n✔ Installation smarter Steuerungssysteme\n✔ Sicherungstechnik-Optimierung\n_Ihr Vorteil:_ Sichere, normgerechte Elektrik für modernes Wohnen und Arbeiten.",
      image: "elektro.png",
      width: 1
    },{
      caption: "Bauprojektleitung & Koordination",
      intro: "Erfolgreiche Bau- und Modernisierungsprojekte brauchen Planung und Steuerung aus einer Hand.\n\nUnsere Leistungen:\n Projektleitung vom Konzept bis zur Abnahme\nBaukoordination aller Gewerke\nTermin- und Budgetkontrolle\nSchnittstelle zwischen Bauherr, Handwerk und Auftraggeber\n\nBeispielhafte Aktivitäten:\n✔ Erstellung von Bauablaufplänen\n✔ Koordination externer Fachfirmen\n✔ Qualitätssicherung auf der Baustelle\nIhr Vorteil: Sie erhalten einen verlässlichen Ansprechpartner, der Ihr Bauvorhaben strukturiert, risikoarm und effizient begleitet.",
      image: "bauen.jpg"
    },{
      caption: "Solar – Nachhaltige Energie für Ihr Zuhause",
      intro: "Nutzen Sie die Kraft der Sonne – ökologisch, effizient und langfristig sparend.\nUnsere Leistungen:\n- Planung & Installation von Solaranlagen\n- Photovoltaik für Eigenverbrauch\n- Integration in Gebäudestromversorgung\n\nBeispiele:\n✔ Solardachlösungen für Neubau & Bestand\n✔ Kombination mit Batteriespeichern\n✔ Beratung zu Fördermöglichkeiten\n_Ihr Vorteil:_ Reduzierte Energiekosten durch erneuerbare Energien und gesteigerte Unabhängigkeit vom Strommarkt.",
      image: "bauen.jpg"
    },{
      caption: "Flaschnerei – Funktional & Wetterfest",
      intro: "Die Flaschnerei trägt entscheidend zur Langlebigkeit Ihres Hauses bei – durch cleveren Schutz vor Feuchtigkeit und Witterung.\n\nUnsere Leistungen:\nDachrinnen, Fallrohre, Blechverkleidungen\n- Abdichtungen an Dachanschlüssen\n- Individuelle Blechlösungen\n\nBeispiele:\n✔ Montage wetterbeständiger Dachrinnen\n✔ Ablaufoptimierung bei Regenwasser\n✔ Metallverkleidungen für Fensterbänke & Fassaden\nIhr Vorteil: Perfekte Funktionalität bei jedem Wetter – maßgeschneidert und passgenau umgesetzt.",
      image: "bauen.jpg"
    },{
      caption: "Bauen heißt Vertrauen",
      intro: "Wer sich entschließt, sein Haus umzubauen, es energetisch zu sanieren oder gar ein neues Zuhause zu schaffen, ist bei uns gut aufgehoben. Mit unserer Erfahrung aus über 40 Jahren wissen wir, was Bauherren bewegt. Deshalb bieten wir Ihnen zu unserem ",
      image:"bauen.jpg"
    },{
      caption: "Farben und Natur im Einklang",
      intro: "Gesundheit und Umweltverantwortung sind vielen Kunden sehr wichtig. Sie achten auf verantwortungsvoll hergestellte Produkte und verbinden damit mehr Lebensqualität. Die neuen CapaGeo Produkte, die wir als einer der ersten Malerbetriebe bevorzugt verwenden, bieten genau das jetzt auch für Innenfarben, Lacke und Holz-Öle.",
      image:"CapaGeo_neu.jpg"
    },{
      caption: "Erfolg ist Teamarbeit",
      intro: "Unsere Kunden können wir nur optimal bedienen, wenn wir Hand in Hand arbeiten. Deshalb fördern wir die Selbstverantwortung jedes Einzelnen und den Zusammenhalt im Menikheim-Team - ob bei Fortbildungen und Veranstaltungen, beim Fahrertraining oder beim Feiern.",
      image:"home_2.jpg"
    },{
      caption: "sDörfle in Kleinaspach",
      intro: "Im Jahr 2014 haben wir zusammen mit einem Architekten die Fassaden von elf Häusle geplant und ausgeführt. Hocheffiziente Steinlamellen-Dämmplatten in Verbindung mit historischen Baustoffen wie Standsteinen, Fachwerk und Holzfassaden verleihen dem Dörfle besonderen Charme.",
      image:"home_5.jpg"
    },
    {
      caption: "Wir suchen Sie!",
      intro: "Engagiert, motiviert, leistungsbereit. Wenn Sie diese Voraussetzungen erfüllen, sind wir an einer Zusammenarbeit mit Ihnen interessiert. Wir suchen laufend Mitarbeiter m/w und bilden Maler m/w/d und Bürokaufleute m/w/d aus. Melden Sie sich gerne! ",
      image: "home_2.jpg"
    },
    {
      caption: "Naturhäusle gefällig?",
      intro: "Mit unseren handerlesenen Partnern unterstützen wir Sie bei Ihrem Vorhaben Ihr Bauprojekt so natürlich wie möglich zu gestalten. Schauen Sie dazu einfach bei unseren Partnern vorbei.",
      image: "naturhaeusle.png"
    }
  ]
};
const mutations = {

};
const actions = {

};
const getters = {
  articles: (state) => state.articles,
};

const articleModule = {
  state,
  mutations,
  actions,
  getters,
};

export default articleModule;
